<template>
  <div class="vx-row">
    <vx-card
      :title="'Assigned Showroom for User: ' + activeUserInfo.displayName"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vx-card title="All Showroom">
            <template slot="actions">
              <vs-checkbox
                v-model="suffixAllSelect"  :vs-value="allSuffix">Select All Suffix
              </vs-checkbox>
            </template>
            <vs-row>
              <vs-col class="mb-2" v-for="(showroom, index) in allSuffix" :key="index" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                <vs-checkbox
                  v-model="showrromForAna.suffix"
                  :vs-value="showroom"
                >{{ showroom }}
                </vs-checkbox>
              </vs-col>
            </vs-row>
            <!--<div class="demo-alignment">
              <div v-for="(showroom, index) in allSuffix" :key="index">
                <vs-checkbox
                  v-model="showrromForAna.suffix"
                  :vs-value="showroom"
                  >{{ showroom }}
                </vs-checkbox>
              </div>
            </div>-->
          </vx-card>
        </div>
        <div class="vx-col md:w-1/2 w-full mb-base">
          <!--<vx-card title="Selected Showroom">
            <div class="demo-alignment">
              <vs-chip color="primary" v-for="(suf, index) in showrromForAna.suffix" :key="index">
                {{suf}}
              </vs-chip>
            </div>
          </vx-card>-->
          <vx-card title="Select Date">
            <div class="demo-alignment ">
              <div class="mb-1 mt-0">
                <div class="vx-col sm:w-1/2 w-full ">
                  <span>Date From<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/2 w-full ">
                  <datepicker
                    :format="formatedDate(showrromForAna.start_date)"
                    v-validate="'required'"
                    placeholder="Select Date"
                    :disabledDates="disabledDates"
                    v-model="showrromForAna.start_date"
                  />
                </div>
              </div>

              <div class="mb-1 mt-0">
                <div class="vx-col sm:w-1/2 w-full ">
                  <span>Date To<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/2 w-full">
                  <datepicker
                    :format="formatedDate(showrromForAna.end_date)"
                    v-validate="'required'"
                    placeholder="Select Date"
                    v-model="showrromForAna.end_date"
                    :disabledDates="disabledDates"
                  />
                </div>
              </div>
            </div>
          </vx-card>
          <div class="vx-row">
            <div class="demo-alignment">
              <!--<vs-button v-if="showrromAssign.suffix_acl.length < 0 || showrromAssign.suffix_acl.length===0" class="mr-3 mb-2" :disabled="!validateForm" @click="updateAssign(showrromAssign)">Save</vs-button>-->

              <vs-button
                class="mb-2"
                color="rgb(0 121 193)"
                :disabled="!validateForm"
                @click="viewAnalytics(showrromForAna), downloadBtn = false"
              >Generate & View Analytics</vs-button> &nbsp;&nbsp;
              <vs-button
                class="mb-2"
                color="rgb(0 121 193)"
                :disabled="downloadBtn"
                @click="downloadana(downloadAnalytics)"
              >Download Analytics as Excel</vs-button>


            </div>
          </div>
        </div>
      </div>

    </vx-card>
    <br />
    <vx-card title="Showroom wise application" class="mt-2">
      <div v-for="(data, index) in viewOnlyUserACLAnalytis.data" :key="index">
        <vx-card :title="index">
          <div class="vx-row mb-2">
            <div  class="vx-col w-1/2 md:w-1/3 xl:w-1/6" v-for="(dt, index) in data" :key="index">
              <div class="custom-card" :class="getOrderStatusColor(dt.status)">
                <span class="title">
                  {{
                    dt.status == "New Application"
                      ? "New Application"
                      : dt.status == "In-Process"
                      ? "In-Process"
                      : dt.status == "Halt"
                      ? "Halt"
                      : dt.status == "Accepted"
                      ? "Accepted"
                      : dt.status == "Rejected"
                      ? "Rejected"
                      : dt.status == "Reviewed"
                      ? "Reviewed"
                      : ""
                  }}
                </span>
                <h2>{{ dt.application }}</h2>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <!-- <SuffixPieChart :application="data" /> -->
          </div>
        </vx-card>
        <br />
      </div>
    </vx-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import StatisticsCardLine from "../components/statistics-cards/StatisticsCardLine";
import analyticsData from "./ui-elements/card/analyticsData.js";
import moment from "moment";
import SuffixPieChart from "./SuffixPieChart";
export default {
  data() {
    return {
      allSuffix: "",
      showrromForAna: {
        start_date: "",
        end_date: "",
        suffix: []
      },
      suffixAllSelect:[],
      downloadBtn:true,
      analyticsData,
      disabledDates: {
        from: new Date(new Date()) // Disable all dates after specific date
      }
    };
  },
  computed: {
    ...mapGetters(["showrooms", "viewOnlyUserACL", "viewOnlyUserACLAnalytis", "downloadAnalytics"]),
    validateForm() {
      return (
        !this.errors.any() &&
        this.showrromForAna.suffix_acl !== [] &&
        this.showrromForAna.start_date !== "" &&
        this.showrromForAna.end_date !== ""
      );
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    }
  },
  mounted() {
    this.$store.dispatch("getShowrooms");
    this.$store.dispatch(
      "getVierOnlyUserACL",
      this.$store.state.AppActiveUser.displayName
    );

    this.suf = this.viewOnlyUserACL.map(function (el) {
      return el.trim();
    });

    this.allSuffix = this.suf.sort();

  },
  watch:{
    suffixAllSelect(val){
      if(val.length> 0){
        val[0].forEach(element => this.showrromForAna.suffix.push(element));
      }else {
        this.showrromForAna.suffix = [];
      }
    }
  },
  methods: {
    viewAnalytics(data) {
      data.start_date = moment(data.start_date).format("yyyy-MM-DD");
      data.end_date = moment(data.end_date).format("yyyy-MM-DD");
      this.$store.dispatch("getViewOnlyUserACLAnalytics", data);
    },
    downloadana(data) {
      //data.start_date = moment(data.start_date).format("yyyy-MM-DD");
      //data.end_date = moment(data.end_date).format("yyyy-MM-DD");
      this.$store.dispatch("downloadanalytics", data);
    },

    formatedDate(date) {
      return moment(date).format("yyyy-MM-DD");
    },
    getOrderStatusColor(status) {
      if (status === "New Application") return "newApplication";
      if (status === "In-Process") return "inProgress";
      if (status === "Halt") return "halt";
      if (status === "Accepted") return "accepted";
      if (status === "Rejected") return "rejected";
      if (status === "Reviewed") return "reviewed";
      return "primary";
    }
  },
  components: {
    Datepicker,
    StatisticsCardLine,
    SuffixPieChart
  }
};
</script>
<style lang="scss">
.clickable {
  cursor: pointer;
}
.custom-card {
  text-align: center;
  padding: 20px 0px;
  border-radius: 5px;
  box-shadow: 0px 0px 8px 3px #eee;
}
.custom-card.newApplication {
  background: #0079c1;
}
.custom-card.inProgress {
  background: #ff9f43;
}
.custom-card.halt {
  background: #ea5455;
}
.custom-card.accepted {
  background: #28c76f;
}
.custom-card.rejected {
  background: #ea5455;
}
.custom-card.reviewed {
  background: #5b3cc4;
}

.custom-card .title {
  font-size: 13px;
  background: #fff;
  padding: 5px 10px;
  border-radius: 15px;
  font-weight: 500;
  box-shadow: 0px 0px 5px 0px #ffffff;
}

.custom-card h2 {
  padding: 14px 0px;
  font-size: 24px;
  font-weight: 700;
}
</style>
